/**
 * Simple notification utility for token refresh events
 * Can be enhanced with toast notifications or other UI feedback
 */

class TokenNotifications {
  static showRefreshWarning() {
    console.warn('🔄 Your session is being refreshed...');
    // You can integrate with your preferred notification system here
    // For example: toast.warning('Session refreshing...')
  }

  static showRefreshSuccess() {
    console.log('✅ Session refreshed successfully');
    // For example: toast.success('Session refreshed')
  }

  static showRefreshError(message) {
    console.error('❌ Session refresh failed:', message);
    // For example: toast.error('Session expired. Please login again.')
  }

  static showLogoutNotice(reason) {
    console.log('🚪 Logged out:', reason);
    // For example: toast.info('You have been logged out')
  }

  static showNetworkError() {
    console.error('🌐 Network error detected');
    // For example: toast.error('Network connection error')
  }

  // Integration method for toast libraries
  static setToastProvider(toastProvider) {
    this.toast = toastProvider;
  }

  // Enhanced notifications when toast provider is available
  static notify(type, message, options = {}) {
    if (this.toast) {
      switch (type) {
        case 'warning':
          this.toast.warning(message, options);
          break;
        case 'success':
          this.toast.success(message, options);
          break;
        case 'error':
          this.toast.error(message, options);
          break;
        case 'info':
          this.toast.info(message, options);
          break;
        default:
          console.log(message);
      }
    } else {
      console.log(`[${type.toUpperCase()}] ${message}`);
    }
  }
}

export default TokenNotifications;
